import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { IoCheckmark, IoGlobeOutline } from 'react-icons/io5'

import { SUPPORTED_LANGUAGES } from '../../utils/language'

const LanguageSwitcher = ({ light = false }) => {
  const { t, i18n } = useTranslation()

  const current = SUPPORTED_LANGUAGES.find((lng) => lng.code === i18n.resolvedLanguage) ?? SUPPORTED_LANGUAGES[0]

  return (
    <Menu as="div" className="relative">
      <Menu.Button
        className={`flex h-9 w-9 items-center justify-center duration-300 rounded-full hover:cursor-pointer ${
          light ? 'hover:bg-white/20' : 'hover:bg-sky-100'
        }`}
        aria-label={t('change_language')}
        title={t('change_language')}
      >
        <IoGlobeOutline className={light ? 'text-white' : 'text-[#073C59]'} size={22} />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-50 w-40 mt-2 py-1 origin-top-right bg-white rounded-lg shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none">
          {SUPPORTED_LANGUAGES.map((language) => (
            <Menu.Item key={language.code}>
              {({ active }) => (
                <button
                  type="button"
                  onClick={() => i18n.changeLanguage(language.code)}
                  className={`${
                    active ? 'bg-gray-50' : ''
                  } w-full flex items-center gap-3 px-4 py-2 text-left text-sm text-[#073C59]`}
                >
                  <language.Icon size={24} />
                  <span className="flex-1">{language.label}</span>
                  {language.code === current.code && <IoCheckmark className="text-[#006EAB]" size={18} />}
                </button>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default LanguageSwitcher
